import { date } from 'quasar';

export default {
  data () {
    return {
      popperOffset: [-1, 3],
      filter: '',
      filteredValues: [],
      inputText: '',
      inputNumber: {},
      searchDelayTimer: null,
      loading: false,
      highlightedButton: null,
      inputDebounce: 500,
      inputTimeoutId: null,
      query: null
    };
  },
  computed: {
    columnsWithFilter () {
      return this.columns.filter(column => column.hasOwnProperty('filter'));
    },
    filtersData () {
      return this.columnsWithFilter.filter(row => !this.isEmpty(row.filter));
    },
    getFilterValues () {
      switch (this.column.type) {
        case 'value':
          if (this.column.hasOwnProperty('values') && typeof this.column.values === 'object') {
            return this.column.values.filter(val => this.column.filter.indexOf(val.value) !== -1).map(val => val.label).join(', ');
          } else {
            return this.column.filter.join(', ');
          }
        case 'bool':
          return this.column.filter ? 'Да' : 'Нет';
        case 'date':
          return this.column.filter.from && this.column.filter.to ?
            `${this.column.filter.from} — ${this.column.filter.to}` :
            this.column.filter.from || this.column.filter.to;
        case 'int':
          if (this.column.filter.from && this.column.filter.to) {
            return `${this.column.filter.from} — ${this.column.filter.to}`;
          } else {
            return this.column.filter.from || this.column.filter.to;
          }
        default:
          return this.column.filter;
      }
    }
  },
  methods: {
    deferredSearch (col) {
      clearTimeout(this.searchDelayTimer);
      this.searchDelayTimer = setTimeout(() => {
        this.search(col);
      }, 500);
    },
    search (column) {
      let query = '',
        routeQuery = {};

      _.forEach(this.filtersData, col => {
        if (query !== '') {
          query += '&';
        }

        if (typeof col.search === 'function') {
            [query, routeQuery] = col.search(query, routeQuery);
        } else if (col.type === 'value') {
          let items = [];

          col.filter.forEach((item, i) => {
            if (i !== 0) query += `&`;
            query += `filter[${col.name}][]=${item}`;
            items.push(item);
          });
          routeQuery = {...routeQuery, ...{[`filter[${col.name}][]`]: items}};
        } else if (col.type === 'date' || col.type === 'int') {
          let items = {};
          Object.keys(col.filter).map((objectKey, i) => {
            if (i !== 0) query += `&`;
            query += `filter[${col.name}][${objectKey}]=${col.filter[objectKey]}`;
            items[`filter[${col.name}][${objectKey}]`] = col.filter[objectKey];
          });
          routeQuery = {...routeQuery, ...items};
        } else if (col.type === 'bool') {
          query += `filter[${col.name}]=${col.filter}`;
          routeQuery = {...routeQuery, ...{[`filter[${col.name}]`]: col.filter}};
        } else if (col.type === 'text') {
          query += `filter[${col.name}]=${col.filter}`;
          routeQuery = {...routeQuery, ...{[`filter[${col.name}]`]: col.filter}};
        }
      });

      this.$store.commit('routeQuery/setFilter', Object.keys(routeQuery).length ? routeQuery : null);
      this.$emit('input', query);
    },
    filterValues (query, col) {
      this.filteredValues = col.values.filter(
        row => row.label.toLowerCase().includes(query.toLowerCase())
      );
    },
    searchValues (query, column) {
      clearTimeout(this.inputTimeoutId);

      if (!query.length) {
        this.updateFilteredValues(this.column);
      }

      if (query.length < 3) {
        return;
      }

      this.inputTimeoutId = setTimeout(() => {
        const request = column.searchRequest(query);

        this.loading = true;
        request
          .then(response => {
            this.filteredValues = response;
            this.addDefaultFilterValues(column);
            this.loading = false;
          });
      }, this.inputDebounce);
    },
    setColumnValues (col, item) {
      if (col.filter.includes(item.value)) {
        col.values.push(item);
      } else {
        col.values = col.values.filter(val => val.value !== item.value);
      }
    },
    addDefaultFilterValues(col) {
      if (col.hasOwnProperty("defaultValues") && col.defaultValues.length) {
        let values = col.defaultValues.filter(
          (defaultValue) => !this.filteredValues.includes(defaultValue)
        );
        this.filteredValues.unshift(...values);
      }
    },
    updateFilteredValues (col) {
      if (col.values.length) {
        this.filteredValues = col.values.filter(
          row => col.filter.includes(row.value)
        );

        if (!col.searchRequest) {
          this.filteredValues = this.filteredValues.concat(col.values.filter(
            row => !col.filter.includes(row.value)
          ));
        }
      }

      this.addDefaultFilterValues(col);
    },
    isEmpty (value) {
      if (!value) {
        return true;
      }

      if (value.constructor === Array && value.length) {
        return false;
      } else if (value.constructor === Object && Object.keys(value).length) {
        return false;
      } else if (value.constructor === String && value !== '') {
        return false;
      }

      return true;
    },
    highlightButton (name) {
      this.highlightedButton = name;
    },
    releaseButton () {
      this.highlightedButton = null;
    },
    focusInput (name) {
      [].concat(this.$refs[`input-${name}`])[0].focus();
    },
    formatDate (val) {
      return date.formatDate(val, 'YYYY-MM-DD');
    }
  }
};


// WEBPACK FOOTER //
// ./resources/assets/js/components/TableFilter/TableFilterBase.js